import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import * as sharingActions from '@store/overviewDashboard/sharing/actions';
import { sharingIsFetchingSelector } from '@store/overviewDashboard/sharing/selectors';
import { PAGE_TYPE } from '@utils/constants';
import ovbBaseSelector from '@store/overviewDashboard/base/selectors';
import { selectors as tabsStoreSelector } from '@store/dashboards/tabs';
import sharing from '../../common/sharing';
import ExperienceDashboard from '../ExperienceDashboard';
import injectorServer from '../../common/injectorServer';

const ovbPageSelector = createSelector(
  ovbBaseSelector,
  tabsStoreSelector,
  sharingIsFetchingSelector,
  (ovbBase, tabsStore, fetching) => ({
    isFetching: fetching,
    isSharing: true,
    ovbBase,
    tabs: tabsStore,
  }),
);

const OverviewSharingDashboard = connect(ovbPageSelector, {
  init: sharingActions.initRequest,
  getSharing: sharingActions.getSharing,
  pageType: PAGE_TYPE.SHARING,
})(sharing()(ExperienceDashboard));

export default injectorServer({}, { pageType: PAGE_TYPE.SHARING })(OverviewSharingDashboard);
